import { useEffect, useState } from 'react';

/** From this width Ivy and one right panel fit beside the video; below it, one side at a time. */
export const BOTH_SIDES_MIN_WIDTH = 1600;

/** Every side in B is this wide: Ivy's rail, Audio and Reviews. */
export const SIDE_WIDTH = 380;

const fits = () => window.innerWidth >= BOTH_SIDES_MIN_WIDTH;

/** Direction B's panel rule. Off (`enabled` false) it always says yes and listens to nothing. */
export function useRoomForBothSides(enabled: boolean): boolean {
  const [room, setRoom] = useState(() => !enabled || fits());

  useEffect(() => {
    if (!enabled) return;
    const onResize = () => setRoom(fits());
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [enabled]);

  return !enabled || room;
}
